import styled from 'styled-components';


export const StyledNotFoundContent = styled.div`
display: inherit;
overflow: hidden;
height: 100%;
width: 100%;
position: absolute;
top: 0px;
left: 0px;

.notFound-container {
  height: 100%;
  width: 100%;
  display: table;
  position: relative;
  left: 0;
  top: 0;
}

.notFound-content {
  padding: 10px 0px 10px 0px;
  border-radius: 1px;
  position: static;
  vertical-align: middle;
  display: table-cell;
}

.notFound-table{
  display: table;
  height: 100%;
  width: 100%;
}

.notFound-table-cell{
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

.notFound-404 {
  border: 2px solid #b90d0d;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  left: 50%;
  margin: 0 auto;
  text-align: center;
  color: #b90d0d;
  font-size: 5em;
}

.notFound-title {
  padding: 10px 0px 20px 0px;
  text-align: center;
  font-size: 1em;
}

.notFound-btn {
  font-size 1em;
  margin: 0 auto;
  padding: 5px;
  text-align: center;
  width: 200px;

  cursor: pointer;
  box-shadow: 1px 1px 2px rgb(171, 169, 169);
  border-radius: 2px;
  background-color: #f2f2f2;
}

.notFound-btn:hover {
  background-color: #d2d2d2;
}

.notFound-arrow {
  padding: 0px 5px 0px 10px;
  font-size: 1em;
}

.notFound-text {
  padding-right: 5px;
}

`;
